import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type IntegrationDictionaries as SchemaIntegrationDictionaries } from '../schemas/IntegrationDictionaries';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Integrations
 */
export const GetYandexMarketCampaignsContentType = '' as const;
export type GetYandexMarketCampaignsRequest = void;
export type GetYandexMarketCampaignsResponses = LinkCommonErrorResponses & {
    /**
     * @description List of Market campaigns available to the connected token, for selecting a VAT source campaign
     */
    '200': {
        'application/json': SchemaIntegrationDictionaries;
    };
};
export type GetYandexMarketCampaignsResponseSuccess = GetYandexMarketCampaignsResponses['200']['application/json'];
export type GetYandexMarketCampaignsSearchParams = undefined;
export type GetYandexMarketCampaignsPathParameters = undefined;
export const GetYandexMarketCampaignsUrl = '/integrations/yamarket/campaigns' as const;
export const GetYandexMarketCampaignsMethod = 'GET' as const;
export const getGetYandexMarketCampaignsUrl = (_params?: GetYandexMarketCampaignsPathParameters) =>
    GetYandexMarketCampaignsUrl;
